<template>
    <router-view></router-view>
</template>

<script>
  import Auth from './api/Auth'
  import Storage from './api/Storage'
  import API from './api/API'
  import Helper from './api/Helper'
//  import MM from '../static/js/Modernizr.js'

  export default {
    name: 'app',
    data () {
      return {
        Auth: Auth,
        Storage: Storage,
        api: API
        // MM: MM
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        Helper.checkLang()
        if (this.$route.fullPath !== '/loading' && this.$route.fullPath !== '/login') {
          Storage.enterRouter = this.$route
        } else {
          Storage.enterRouter = {fullPath: '/', query: {}}
        }
        if (this.$route.path !== '/impersonate') {
          Auth.check(this)
        } else {
          Storage.enterRouter = {fullPath: '/', query: {}}
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?aa01c016